import { isProduction } from './utils/environment-utils';

const noop = () => {};

export const SCRIBE_CONFIG = {
  appName: 'express-tracking',
  custType: 'pax',
};

export const SCRIBE_EVENT_PARAMS = {
  STATE_NAME: 'STATE_NAME',
};

/**
 * Inits the Scribe SDK if it is not initialized and return the instance
 */
export const getScribeSDK = () => {
  if (!window || !window.scribesdk)
    return {
      initialize: noop,
      sendEvent: noop,
      setAuthToken: noop,
      setFacets: noop,
      forceUpdate: noop,
    };

  if (!window.scribeInitDone) {
    window.scribesdk.initialize(
      SCRIBE_CONFIG.appName,
      SCRIBE_CONFIG.custType,
      isProduction(),
    );
    window.scribeInitDone = true;
  }

  return window.scribesdk;
};

export const scribeTrackEvent = ({
  stateName,
  eventName,
  facets = {},
  forceUpdate = false,
}) => {
  if (!isProduction()) {
    // eslint-disable-next-line no-console
    console.log('[SCRIBE DEBUG]', { stateName, eventName, facets });
  }

  const scribeSDK = getScribeSDK();
  try {
    const scribePromise = scribeSDK.sendEvent(eventName, {
      ...facets,
      [SCRIBE_EVENT_PARAMS.STATE_NAME]: stateName,
    });
    if (forceUpdate) {
      scribeSDK.forceUpdate();
    }
    return scribePromise;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error({
      scribeTrackingErr: e,
    });
  }
  return Promise.resolve();
};
